<template>
  <div id="loginBox">
    <h1>
      <img src="../../assets/img/logo.png" alt="同济老年大学" />
    </h1>
    <div>
      <idcards></idcards>
    </div>
  </div>
</template>

<script>
import idcards from "../login/loginAsIdcard";
export default {
  data() {
    return {
      idcard: true
    };
  },
  components: {
    idcards
  },
  created() {}
};
</script>

<style scoped lang="less">
@import '../../styles/base/_variables';
@import '../../styles/base/_mixins';

// 登录页面样式
#loginBox {
  width: 45%;
  max-width: 700px;  // 使用 max-width 替代 min() 函数
  height: 600px;  // 固定高度，防止内容变化导致高度变化
  margin: 10vh auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;  // 改为顶部对齐
  border: 1px solid @border-color;
  border-radius: 10px;
  .box-shadow();
  padding: 70px 20px;
  text-align: center;
  position: relative;  // 为内部元素定位做准备
  overflow: hidden;  // 防止内容溢出

  h1 {
    margin-bottom: 60px;
    flex-shrink: 0;  // 防止标题被压缩
    img {
      max-width: 100%;
      height: auto;
    }
  }

  > div {
    flex: 1;  // 占据剩余空间
    display: flex;
    flex-direction: column;
    justify-content: center;  // 垂直居中wechat组件
    min-height: 0;  // 允许内容滚动
  }
}

// 移动端适配
@media(max-width: @screen-sm) {
  #loginBox {
    height: auto;  // 移动端使用自适应高度
    min-height: 80vh;  // 设置最小高度
    padding: 10vh 0 0 0;  // 统一顶部内边距，其他边为0
    width: 92%;
    margin: auto;
    border: none;
    border-radius: 0;
    box-shadow: none;
    background: transparent;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;  // 统一顶部对齐
    h1 {
      margin-bottom: 32px;
      font-size: 24px;
      flex-shrink: 0;
      height: auto;  
    }

    > div {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      min-height: 0;
    }
  }
}

</style>
